import { Link, useLoaderData } from "react-router-dom"
import { BuddyTile } from "../components/BuddyTile"
import { Button } from "../components/Button"
import { useNavigate } from "react-router-dom"
import mixpanel from "../services/mixpanel";
import { useEffect } from "react";
import { getUserId } from "../services/helpers";

export function Buddies(){
	const navigate = useNavigate();
	const loaderData = useLoaderData();
	const buddies = loaderData.buddies;
	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);
	return (
		<main id="BuddiesPage">
		<h1>Buddies</h1>

		<div className="row" id="page-actions">
			<Link>All Buddies</Link>
			<Button label="Add Buddy" onClick={()=>{navigate("/dashboard/buddies/add_buddy")}} color="blue"/>
		</div>


		{/* <BuddyTile />
		<BuddyTile />
		<BuddyTile /> */}
		{buddies.buddies.map((buddy) => (
			<BuddyTile key={buddy.buddy_id} buddy={buddy} />
		))}

		</main>
	)
}

// buddy_id: 3, email: "kwekuaacquaye@gmail.com", phone_number: "0559582518",